import { EndpointBuilder } from "@reduxjs/toolkit/query";
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from "@reduxjs/toolkit/query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import {
  AuthToken,
  NewAccessTokenResponse,
  VerifyMfa,
  authenticateUser,
  changePassword,
  confirmChangePassword,
  forcedChangePassword,
  setUpMFA
} from "../types";
import { ResponseBaseWithoutData } from "@/store/user-access-panel/types";

export const authloginEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    "authApi"
  >
) => ({
  signInUser: builder.mutation<
    AuthToken,
    {
      email?: string;
      password?: string;
      authFlow: string;
      refreshToken?: string;
    }
  >({
    query: (data) => ({
      url: "/auth/users/sign-in",
      method: "POST",
      body: data
    })
  }),
  verifyMFA: builder.mutation<
    VerifyMfa,
    { email: string; mfaCode: string; session: string; challengeName: string }
  >({
    query: (data) => ({
      url: "/auth/users/verify-mfa",
      method: "POST",
      body: data
    })
  }),
  forcedChangePassword: builder.mutation<
    forcedChangePassword,
    {
      email: string;
      confirmPassword: string;
      session: string;
      newPassword: string;
      oldPassword: string;
    }
  >({
    query: (data) => ({
      url: "/auth/users/force-change-password",
      method: "PATCH",
      body: data
    })
  }),
  setUpMFA: builder.mutation<setUpMFA, { mfaCode: string; session: string }>({
    query: (data) => ({
      url: "/auth/users/confirm-mfa",
      method: "POST",
      body: data
    })
  }),
  authenticateUser: builder.mutation<authenticateUser, { accessToken: string }>(
    {
      query: ({ accessToken }) => ({
        url: "/auth/users/authenticate",
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    }
  ),
  confirmChangePasswordUser: builder.mutation<
    confirmChangePassword,
    {
      email: string;
      newPassword: string;
      confirmPassword: string;
      confirmationCode: string;
    }
  >({
    query: (data) => ({
      url: "/auth/users/confirm-forgot-password",
      method: "POST",
      body: data
    })
  }),
  changePasswordUser: builder.mutation<changePassword, { email: string }>({
    query: (data) => ({
      url: "/auth/users/forgot-password",
      method: "POST",
      body: data
    })
  }),
  getNewAccessToken: builder.mutation<
    NewAccessTokenResponse,
    { refreshToken: string | null }
  >({
    query: (data) => ({
      url: "/auth/users/new-access-token",
      method: "POST",
      body: data
    })
  }),
  signOutUser: builder.query<ResponseBaseWithoutData, "">({
    query: () => ({
      url: "/auth/users/sign-out"
    })
  })
});
